import React, { useEffect, useState } from 'react'
import AppSidebar from '../../components/AppSidebar';
import AppHeader from '../../components/AppHeader';
import { useForm, Controller } from 'react-hook-form';
import PageHeader from '../../components/PageHeader';
import UsersService from '../../services/UsersService';
import { toast, ToastContainer } from 'react-toastify';
import CompanyService from '../../services/CompanyService';
import AsyncSelect from 'react-select/async';
import Select from 'react-select'
import { useNavigate } from 'react-router-dom/dist';
import { useAuth } from '../../contexts/AuthContext';
import RolesService from '../../services/RolesService';
import DepartmentService from '../../services/DepartmentService';
import DesignationService from '../../services/DesignationService';

const CreateUser = () => {
  const {register, handleSubmit, control, formState: {errors}, setError, setValue} = useForm({
    defaultValues: {
      password: 'Qwaszx@123',
      status: 'active',
    },
  });
  const {user} = useAuth();
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [designationOptions, setDesignationOptions] = useState([]);

  const fetchRoleOptions = async(inputValue) => {
    try{
      const roleList = await RolesService.listAll(inputValue);
      if(roleList && Array.isArray(roleList.data.data)){
        return roleList.data.data.map(role => ({
          value: role.id,
          label:role.label
        }));
      }else{
        console.error('Expected an array in roleList.data.data, but got:', roleList.data);
        return [];
      }
    }catch(error){
      console.error('Error fetching roles:', error);
      return [];
    }
  }

  const fetchDepartmentOptions = async() => {
    try{
      const response = await DepartmentService.listAll();
      if(response && Array.isArray(response.data.data)){
        const departmentlist = response.data.data.map(department => ({
          value: department.id,
          label:department.name
        }));
        setDepartmentOptions(departmentlist);
      }else{
        console.error('Expected an array in departmentList.data.data, but got:', response.data);
        return [];
      }
    }catch(error){
      console.error('Error fetching departments:', error);
      return [];
    }
  }

  const fetchDesignationOptions = async(departmentId) => {
    try{
      const response = await DesignationService.listAll(departmentId);
      if(response && Array.isArray(response.data.data)){
        const designationlist = response.data.data.map(designation => ({
          value: designation.id,
          label:designation.name
        }));
        setDesignationOptions(designationlist);
      }else{
        console.error('Expected an array in designationList.data.data, but got:', response.data);
        return [];
      }
    }catch(error){
      console.error('Error fetching designations:', error);
      return [];
    }
  }

  useEffect(() => {
    if (user?.company_id) {
      fetchCompanyOptions("").then(options => {
        const matched = options.find(opt => opt.value === user.company_id);
        if (matched) {
          setSelectedCompany(matched);
          setValue("company_id", matched.value); // ✅ Important
        }
      });
    }
    fetchDepartmentOptions();
  }, [user]);

  const onSubmit = async(data) => {
    try{
      await UsersService.create({data})
      toast.success('User created successfully!');
      setTimeout(() => {
        navigate('/user');
      }, 1000);
    }catch(error){
      if(error.errors){
        error.errors.forEach((fieldError) => {
          setError(fieldError.field, {
            type: 'manual',
            message: fieldError.message.isNotEmpty
          })
        });
      }else{
        console.log('Error in creating user:',  [error]);
        toast.error(error?.response?.data?.message || 'An error occurred.');
      }
    }
  }

  const fetchCompanyOptions = async(inputValue) => {
    try{
      const companyList = await CompanyService.listAll(inputValue);
      if(companyList && Array.isArray(companyList.data.data)){
        return companyList.data.data.map(company => ({
          value: company.id,
          label:company.name
        }));
      }else{
        console.error('Expected an array in companyList.data.data, but got:', companyList.data);
        return [];
      }
    }catch(error){
      console.error('Error fetching companies:', error);
      return [];
    }
  }
  const handlePhoneInputChange = (e) => {
    e.target.value = e.target.value.replace(/[^0-9]/g, '').slice(0, 10);
  };
  return (
    <>
      <AppSidebar />
      <div className="main-content">
        <AppHeader />
        <div className="container-fluid">
          <div className="row justify-content-center">
            <div className="col-12 col-lg-10 col-xl-12">
              <PageHeader
                title='User'
                 button_label1="Back"
                 link_to1="/user" className1="btn btn-primary btn-sm"
              />
              
              <div className="container-fluid">
                <div className="card row p-4">
                  <form id="customer-form" onSubmit={handleSubmit(onSubmit)}>
                    <div className="row">
                      <div className="col-12 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="form-label">Company</label>
                          <Controller
                            name="company_id"
                            control={control}
                            rules={{ required: "Company is required" }}
                            render={({field}) => (
                              <AsyncSelect
                                {...field}
                                cacheOptions
                                defaultOptions
                                loadOptions={fetchCompanyOptions}
                                onChange={(selectedOption) => {
                                  setSelectedCompany(selectedOption);
                                  field.onChange(selectedOption ? selectedOption.value : null);
                                }} 
                                value={selectedCompany}
                                placeholder="Select a company"/>
                            )}
                          />
                          {errors.company_id && <div className="text-danger">{errors.company_id.message}</div>}
                        </div>
                      </div>                      
                      <div className="col-12 col-md-6 mb-4">
                        <div className="form-group">
                          <label className="form-label">Name</label>
                          <input
                            type="text"
                            {...register('name', {
                              required: 'The name field is required.',
                              validate: value => typeof value === 'string' || 'Name must be a string'
                            })}
                            className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                          />
                          {errors.name && <div className="text-danger">{errors.name.message}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group pb-4">
                          <label className="mb-1 form-label">Email address</label>
                          <input
                            type="email"
                            {...register('email', { 
                              required: "The email field is required.",
                              pattern: {
                                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                message: "Email must be a valid email address"
                              }
                            })}
                            className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                          />
                          {errors.email && <div className="invalid-feedback">{errors.email.message}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group pb-4">
                          <label className="mb-1 form-label">Phone no</label>
                          <input
                            type="tel"
                            maxLength={10}
                            {...register('phone',{
                              required: "The phone number field is required.",
                              minLength: {
                                value: 10,
                                message: "The phone number must be 10 digits number"
                              },
                              maxLength: {
                                value: 10,
                                message: "The phone number must be 10 digits number"
                              },
                              pattern: {
                                value: /^[0-9]+$/,
                                message: "Phone number must contain only digits"
                              }
                            })}
                            onInput={handlePhoneInputChange}
                          className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                          />
                         {errors.phone && <div className="text-danger">{errors.phone.message}</div>}

                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="form-group pb-4">
                          <label className="mb-1 form-label">Password</label>
                          <input
                            type="password"
                            maxLength={30}
                            {...register('password',{
                              required: "The password field is required.",
                              minLength: {
                                value: 6,
                                message: "The password length must be 6 h"
                              },
                            })}
                            className={`form-control ${errors.password ? 'is-invalid' : ''}`}
                          />
                         {errors.password && <div className="text-danger">{errors.password.message}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 mb-3">
                        <div className="form-group">
                          <label className="form-label">Department</label>
                          <Controller
                            name="department_id"
                            control={control}
                            rules={{ required: "The department field is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={departmentOptions}
                                placeholder="Select a department"
                                isSearchable
                                classNamePrefix="react-select"
                                value={departmentOptions.find(option => option.value === field.value) || null}
                                onChange={(selectedOption) => {
                                  field.onChange(selectedOption?.value);
                                  fetchDesignationOptions(selectedOption?.value);
                                }}
                              />
                            )}
                          />
                          {errors.department_id && <div className="text-danger">{errors.department_id.message}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 mb-3">
                        <div className="form-group">
                          <label className="form-label">Designation</label>
                          <Controller
                            name="designation_id"
                            control={control}
                            rules={{ required: "The designation field is required" }}
                            render={({ field }) => (
                              <Select
                                {...field}
                                options={designationOptions}
                                placeholder="Select a designation"
                                isSearchable
                                classNamePrefix="react-select"
                                value={designationOptions.find(option => option.value === field.value) || null}
                                onChange={(selectedOption) => field.onChange(selectedOption?.value)}
                              />
                            )}
                          />
                          {errors.designation_id && <div className="text-danger">{errors.designation_id.message}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-6 ">
                        <div className="form-group pb-4">
                          <label className="mb-1 form-label">Role</label>
                          <Controller
                            name="roles"
                            control={control}
                            rules={{ required: "Role is required" }}
                            render={({field}) => (
                              <AsyncSelect
                                {...field}
                                cacheOptions
                                defaultOptions
                                isMulti ={true}
                                loadOptions={fetchRoleOptions}
                                onChange={(selectedOption) => {
                                  setSelectedRole(selectedOption);
                                  field.onChange(selectedOption ? selectedOption.map(opt => opt.value) : []);
                                }}
                                value={selectedRole}
                                placeholder="Select a role"/>
                            )}
                          />
                         {errors.roles && <div className="text-danger">{errors.roles.message}</div>}
                        </div>
                      </div>
                      <div className="col-12 col-md-12 mb-4">
                        <div className="form-group pb-4">
                          <label className="mb-1 form-label">Status</label>
                          <select {...register('status', { required: 'Status is required' })}
                            className={`form-select ${errors.status ? 'is-invalid' : ''}`}>
                            <option value="">Select</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                          </select>
                          {errors.status && <div className="text-danger">{errors.status.message}</div>}
                        </div>
                      </div>
                    </div>
                    <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                      Create
                    </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  )
}

export default CreateUser